import useActivityTracker from "../utils/hooks/user/useUserActivityTracker";

const UserActivityTracker = () => {
  useActivityTracker();

  return <></>;
};

export default UserActivityTracker;
